module.exports = __webpack_public_path__ + "static/media/gallery3.94f2ed11.jpg";